import { StyledSearchBar, useDebouncedSearch } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { useRecoilState } from 'recoil';
import { searchLinkState } from '../../storage/links';

function LinkFilters() {
  const { search, setSearch } = useDebouncedSearch(useRecoilState(searchLinkState));

  return (
    <StyledSearchBar
      name={'link-search'}
      value={search}
      onChange={(value) => setSearch(value)}
      clearable
      noMargin
    />
  );
}

export default memo(LinkFilters);
